<template>
	<div
		v-if="!user || user.email.includes('guest.quomi.it')"
		class="container"
	>
		<div
			class="slides-container flex"
			@touchstart="touchstart($event.touches[0].pageX)"
			@touchmove="touchmove($event.touches[0].pageX)"
			@touchend="touchend($event)"
			:class="[`slide-${-transform}`]"
		>
			<div
				class="slide"
				:class="{'smooth': !touchpathX }"
				:style="[basic, slide.isImageLoaded ? background(index) : null]"
				v-for="(slide, index) in slides"
			/>

			<div class="fixed">
				<div class="label-group">
					<img :src="require('../../assets/img/logo/quomi.svg')">
					<div class="label">
						<p class="title"><b>{{ slides[-transform].title }}</b></p>
						<p>{{ slides[-transform].par }}</p>
					</div>
				</div>

				<div class="dots">
					<div v-for="n in itemsLength" class="dot inline" :class="{ 'active': -n === transform-1 }" />
				</div>

				<div class="button-group">
					<CTA
						@click="openLoginForm({ showLogin: true })"
						:content="`Accedi`"
						:size="`small`"
						:color="`orange`"
					/>	

					<CTA
						@click="$router.push({'name': 'flow-subscribed'})"
						:content="`Ordina ora`"
						:size="`small`"
					/>	
				</div>
			</div>
		</div>

		<WebviewLoginForm
			ref="loginForm"
		/>
	</div>
</template>

<script>

import WebviewLoginForm from './WebviewLoginForm'

export default {
	data () {
		return {
			
			touchstartX: 0,
			touchcurrentX: 0,
			transform: 0,
			longTouch: false,
			numSlides: 1,
			itemsLength: 4,

			slides: [
				{
					isImageLoaded: false,
					image: require('../../assets/img/wizard/0.jpg'),
					title: 'La Spesa Online, dal Produttore alla tua Tavola',
					par: 'Fai la tua spesa online con kit ricette, cassette di frutta e verdura e tanti prodotti freschi e di qualità da più di 80 Produttori di Alta Qualità'
				},
				{
					isImageLoaded: false,
					image: require('../../assets/img/wizard/1.jpg'),
					title: '1. Pianifica le tue cene',
					par: 'Scegli il piano più adatto a te e componi la tua spesa di ricette'
				},
				{
					isImageLoaded: false,
					image: require('../../assets/img/wizard/2.jpg'),
					title: '2. Ricevi gli ingredienti',
					par: 'Ogni settimana un box con ingredienti freschi e stagionali'
				},
				{
					isImageLoaded: false,
					image: require('../../assets/img/wizard/3.jpg'),
					title: '3. Prepara piatti deliziosi',
					par: 'Divertiti in cucina con le nostre semplici istruzioni'
				}
			]
		}
	},

	computed: {
		user () {
			return this.$root.user
		},

		basic () {
			return {
				transform: 'translate3d(' + this.touchpathX + 'px, 0px, 0px) translate3d(' + this.transform * 100 + '%, 0px, 0px)'
			}
		},

		touchpathX () {
			const swipeLeft = () => this.touchcurrentX - this.touchstartX > 0
			const isOnFirstSlide = () => this.transform === 0
			const swipeRigth = () => this.touchcurrentX - this.touchstartX < 0
			const isOnLastSlide = () => this.transform === -(this.itemsLength - 1)

			if (swipeLeft() && isOnFirstSlide()) return
			if (swipeRigth() && isOnLastSlide()) return
			return this.touchcurrentX - this.touchstartX
		}
	},

	components: {
		WebviewLoginForm
	},

	methods: {
		background (index) {
			return {
				backgroundImage: `url(${this.slides[index].image})`
			}
		},
		openLoginForm (params) {
			this.$refs.loginForm.open()
			if (params) {
				this.$refs.loginForm.isToShowLogin = params.showLogin
			}
		},

		next () {
			if (this.transform > -(this.itemsLength - this.numSlides)) this.moveLeft()
		},

		prev () {
			if (this.transform < 0) this.moveRight()
		},

		moveLeft () {
			this.transform--
		},

		moveRight () {
			this.transform++
		},

		touchstart (x) {
			this.touchstartX = x
			this.touchcurrentX = this.touchstartX

			this.longTouch = false
			setTimeout(() => {
				this.longTouch = true
			}, 250)
		},

		touchmove (x) {
			this.touchcurrentX = x
		},

		touchend (event) {
			var elem = document.getElementsByClassName('slide')[0]
			var elemW = elem ? elem.offsetWidth : 0

			const isSwipe = () => {
				return !this.longTouch
			}

			const moreThenHalf = () => {
				return elemW === 0 ? false : Math.abs(this.touchpathX) > elemW / 2
			}

			if (isSwipe() || moreThenHalf()) {
				if (this.touchpathX > 0) this.prev()
				if (this.touchpathX < 0) this.next()
			}
			this.touchcurrentX = 0
			this.touchstartX = 0
		},
	},

	mounted () {
		this.slides.forEach(slide => {
			var image = new Image()

			image.onload = () => {
				slide.isImageLoaded = true
			}

			image.src = slide.image
		})
	}
}
</script>

<style scoped>

.dots {
}

.dot {
	margin: 10px;
	width: 8px;
	height: 8px;
	border: 1px solid white;
	background-color: white;
	border-radius: 50%;
}

.dot.active {
	border: 1px solid var(--quomi-primary);
	background-color: var(--quomi-primary);
}

.smooth {
	transition: transform ease 0.7s;
}

.slides-container {
	position: absolute;
	top: 0;
	bottom: 0;
	width: 100%;
	overflow: hidden;
}

.slide {
	padding-top: 120px;
	position: relative;
	background-color: #e1e9e1;
	flex-basis: 100%;
	min-width: 100%;
	background-size: cover;
	background-position: center center;
}

.fixed {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
}

.label {
	color: black;
	border-radius: 6px;
	background: white;
	text-align: center;
	padding: 30px 20px 15px 20px;
	font-size: 14px;
}

p {
	margin-bottom: 0.5rem;
}

.label-group {
	margin-top: 20%;
	z-index: 2;
	top: 0px;
	left: 50%;
}

.label-group img {
	width: 60px;
	height: 60px;
	margin: 0 auto;
	display: block;
	transform: translateY(20px);
	z-index: 2;
    position: relative;
}

.label-group,
.button-group {
	width: 90%;
	max-width: 300px;
}

.button-group .btn {
	width: 100%;
	margin-top: 20px;
}

</style>
